import gsap from "gsap";

function navBar() {
	const gsap = window.gsap;
	const header = document.querySelector(".header");
	const menu = document.querySelector("#menu");
	const controls = document.querySelectorAll('[aria-controls="menu"]');

	if (!header || !menu || !controls.length) return;

	const mainView = menu.querySelector(".menu__view--main");
	const downloadsView = menu.querySelector(".menu__view--downloads");
	const menuItems = menu.querySelectorAll(".menu__nav-item-link");
	const downloadItems = menu.querySelectorAll(".menu__download-link");
	const downloadsTriggers = menu.querySelectorAll('a[href="#downloads"]');
	const mainMenuButton = menu.querySelector(".menu__main-menu");
	const hasHomeHero = document.body.classList.contains("has-home-hero");

	function updateHeaderState() {
		const scrollThreshold = hasHomeHero ? window.innerHeight * 0.75 : 120;
		const isScrolled = window.scrollY > scrollThreshold;

		header.classList.toggle("is-scrolled", isScrolled);

		if (hasHomeHero && isScrolled) {
			document.body.classList.add("header-visible");
		}
	}

	function fadeIn(items, delay = 0) {
		if (!gsap) return;

		gsap.killTweensOf(items);
		gsap.fromTo(
			items,
			{ autoAlpha: 0 },
			{
				autoAlpha: 1,
				duration: 0.6,
				delay,
				stagger: 0.08,
				ease: "power2.out",
				onComplete: () => {
					gsap.set(items, {
						clearProps: "opacity,visibility,transform",
					});
				},
			},
		);
	}

	function setView(activeView) {
		[mainView, downloadsView].forEach((view) => {
			if (!view) return;

			const isActive = view === activeView;

			view.classList.toggle("is-active", isActive);
			view.setAttribute("aria-hidden", isActive ? "false" : "true");
			view.toggleAttribute("inert", !isActive);
		});
	}

	function fadeToView(activeView, items) {
		if (!gsap) {
			setView(activeView);
			return;
		}

		const currentView = menu.querySelector(".menu__view.is-active");

		gsap.set(items, { autoAlpha: 0 });

		if (!currentView || currentView === activeView) {
			setView(activeView);
			fadeIn(items);
			return;
		}

		gsap.killTweensOf([currentView, activeView]);
		activeView.classList.add("is-active");
		activeView.setAttribute("aria-hidden", "false");
		activeView.removeAttribute("inert");
		gsap.set(activeView, { autoAlpha: 0 });

		gsap.to(currentView, {
			autoAlpha: 0,
			duration: 0.3,
			ease: "power2.out",
			onComplete: () => {
				currentView.classList.remove("is-active");
				currentView.setAttribute("aria-hidden", "true");
				currentView.setAttribute("inert", "");
				gsap.set(currentView, { clearProps: "opacity,visibility" });
			},
		});

		gsap.to(activeView, {
			autoAlpha: 1,
			duration: 0.3,
			ease: "power2.out",
			onComplete: () => {
				gsap.set(activeView, { clearProps: "opacity,visibility" });
			},
		});

		fadeIn(items, 0.1);
	}

	function openMenu() {
		document.body.classList.add("menu-open");
		menu.classList.add("open");
		menu.setAttribute("aria-hidden", "false");
		menu.removeAttribute("inert");

		controls.forEach((control) => {
			control.setAttribute("aria-expanded", "true");
		});

		setView(mainView);

		if (gsap) {
			gsap.set(downloadItems, { autoAlpha: 0 });
			fadeIn(menuItems, 0.3);
		}
	}

	function closeMenu() {
		document.body.classList.remove("menu-open");
		menu.classList.remove("open");
		menu.setAttribute("aria-hidden", "true");
		menu.setAttribute("inert", "");

		controls.forEach((control) => {
			control.setAttribute("aria-expanded", "false");
		});

		if (gsap) {
			gsap.set([...menuItems, ...downloadItems], { autoAlpha: 0 });
		}
	}

	function toggleMenu(event) {
		event.preventDefault();

		if (document.body.classList.contains("menu-open")) {
			closeMenu();
		} else {
			openMenu();
		}
	}

	function showDownloads(event) {
		event.preventDefault();
		fadeToView(downloadsView, downloadItems);
	}

	function showMainMenu() {
		fadeToView(mainView, menuItems);
	}

	controls.forEach((control) => {
		control.addEventListener("click", toggleMenu);
	});

	downloadsTriggers.forEach((trigger) => {
		trigger.addEventListener("click", showDownloads);
	});

	if (mainMenuButton) {
		mainMenuButton.addEventListener("click", showMainMenu);
	}

	window.addEventListener(
		"scroll",
		() => {
			updateHeaderState();
		},
		{ passive: true },
	);

	document.body.classList.add("header-visible");

	window.addEventListener("keydown", (event) => {
		if (event.key === "Escape") closeMenu();
	});

	updateHeaderState();
}

navBar();
